import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './App.css';

// Web Pages
import LandingPage from './pages/LandingPage';
import TripSummaryPage from './pages/TripSummaryPage';
import ProfilePage from './pages/ProfilePage';
import BackendIndicator from './components/BackendIndicator';
import RouteGuidePage from './pages/RouteGuidePage';
import GuidesIndexPage from './pages/GuidesIndexPage';
import CookieConsentBanner from './components/Common/CookieConsentBanner';
import { enableAnalytics, getAnalyticsConsent, subscribeToAnalyticsConsent } from './utils/analyticsConsent';

// Import web CSS
import './css/style.css';
import TestMapAccuracy from './pages/TestMapAccuracy';

function RedirectToDownload() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true, state: { scrollTarget: 'download' } });
  }, [navigate]);

  return null;
}

function AppLayout() {
  const location = useLocation();
  const showGlobalLegalFooter = location.pathname !== '/';

  return (
    <div className="App">
      <main className="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/planner" element={<RedirectToDownload />} />
          <Route path="/app" element={<RedirectToDownload />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/trip-summary" element={<TripSummaryPage />} />
          <Route path="/guides" element={<GuidesIndexPage />} />
          <Route path="/guides/:slug" element={<RouteGuidePage />} />
          <Route path="/health" element={<TestMapAccuracy />} />
          <Route path="/backend-check" element={<BackendIndicator />} />
        </Routes>
      </main>
      {showGlobalLegalFooter && (
        <footer className="legal-footer">
          <span className="legal-footer-brand">&copy; 2026 Whe2. All rights reserved.</span>
          <span className="legal-footer-separator" aria-hidden="true">•</span>
          <a href="/legal/privacy-policy.html" target="_blank" rel="noreferrer">Privacy</a>
          <span className="legal-footer-separator" aria-hidden="true">•</span>
          <a href="/legal/terms-and-conditions.html" target="_blank" rel="noreferrer">Terms</a>
        </footer>
      )}
    </div>
  );
}

function App() {
  useEffect(() => {
    if (getAnalyticsConsent() === 'granted') {
      enableAnalytics();
    }

    return subscribeToAnalyticsConsent((value) => {
      if (value === 'granted') {
        enableAnalytics();
      }
    });
  }, []);

  return (
    <Router>
      <>
        <AppLayout />
        <CookieConsentBanner />
      </>
    </Router>
  );
}

export default App;
